import { Controller } from "@hotwired/stimulus"

// Flash 通知を制御するコントローラ。バナー・モーダルのどちらの見せ方でも同じ閉じ方をする。
// CSP（script-src）でインラインの onclick 属性はブロックされるため、Stimulus 経由で閉じる。
// チェックイン成功モーダル（<dialog>）では、表示と同時に開く。
// dismissAfterValue（ミリ秒）を指定すると、その時間が経過したあとに自動で閉じる。
// fadeOut クラスを指定すると、そのクラスを付けてフェードアウトさせてから取り除く。
// フェードアウトの時間は、要素側の transition と fadeDurationValue（ミリ秒）を揃えること。
export default class extends Controller {
  static classes = ["fadeOut"]
  static values = {
    dismissAfter: Number,
    fadeDuration: { type: Number, default: 500 }
  }

  connect() {
    if (this.element instanceof HTMLDialogElement) this.element.showModal()

    if (this.dismissAfterValue <= 0) return

    this.dismissTimer = setTimeout(() => this.close(), this.dismissAfterValue)
  }

  disconnect() {
    clearTimeout(this.dismissTimer)
    clearTimeout(this.removeTimer)
  }

  close() {
    if (!this.hasFadeOutClass) {
      this.element.remove()
      return
    }

    this.element.classList.add(...this.fadeOutClasses)
    this.removeTimer = setTimeout(() => this.element.remove(), this.fadeDurationValue)
  }
}
